import { render, staticRenderFns } from "./item-image-approved.vue?vue&type=template&id=1a49188e&scoped=true&"
import script from "./item-image-approved.vue?vue&type=script&lang=js&"
export * from "./item-image-approved.vue?vue&type=script&lang=js&"
import style0 from "./item-image-approved.vue?vue&type=style&index=0&id=1a49188e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a49188e",
  null
  
)

export default component.exports